// extracted by mini-css-extract-plugin
module.exports = {"section_testimonial":"testimonial_section_testimonial__j4JS7","wrapper":"testimonial_wrapper__e_0RT","sub_title":"testimonial_sub_title__SG_1H"};